// PROGRAM: Nav — Hit counter, search, active states
// Split from retro-utilities.js

(function() {
    'use strict';

    var Nav = {
        init: function() {
            // Hit counter
            var counterEl = document.getElementById('visitor-counter');
            if (counterEl) {
                var count = localStorage.getItem('retro_hit_count_clean');
                if (!count) {
                    count = 1;
                } else {
                    count = parseInt(count) + 1;
                }
                localStorage.setItem('retro_hit_count_clean', count);
                var paddedCount = count.toString().padStart(6, '0');
                counterEl.innerText = paddedCount;
            }

            // Day stamp
            this.updateDayStamp();
        },

        updateDayStamp: function() {
            var days = ['SUN', 'MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT'];
            var colors = ['FF0000', '000080', '008000', 'FFD700', '800080', '008080', 'C0C0C0'];
            var textColors = ['FFFFFF', 'FFFFFF', 'FFFFFF', '000000', 'FFFFFF', 'FFFFFF', '000000'];

            var now = new Date();
            var dayIndex = now.getDay();

            var icon = document.getElementById('day-stamp');
            if (icon) {
                icon.src = 'https://placehold.co/32x32/' + colors[dayIndex] + '/' + textColors[dayIndex] + '?text=' + days[dayIndex];
            }
        }
    };

    // Register with PROGRAMS
    window.PROGRAMS.register('Nav', Nav);

})();
